import { render, staticRenderFns } from "./MobileResponsiveShell.vue?vue&type=template&id=590545b7&scoped=true"
import script from "./MobileResponsiveShell.vue?vue&type=script&lang=js"
export * from "./MobileResponsiveShell.vue?vue&type=script&lang=js"
import style0 from "./MobileResponsiveShell.vue?vue&type=style&index=0&id=590545b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590545b7",
  null
  
)

export default component.exports